import React from "react"
import { QueryClient, QueryClientProvider } from "react-query"
import { Provider } from "react-redux"
import { RecoilRoot } from "recoil"
import BootstrapApplication from "./components/BootstrapApplication"
import { createStore } from "./redux/store"
import { initReactI18next } from "react-i18next"
import i18next from "i18next"

const preloadedState = require("../config/preloaded-state.json")
const translationFile = require("../config/translation.json")

const name = preloadedState.application.name
const lng = preloadedState.application.language ?? "en-US"

i18next.use(initReactI18next).init({
  debug: process.env.GATSBY_ACTIVE_ENV !== "production",
  lng,
  returnEmptyString: false,
  fallbackLng: "en-US",
  resources: {
    "en-US": {
      translation: translationFile,
    },
    [lng]: {
      translation: translationFile,
    },
  },
})

export const store = createStore({ name, preloadedState })

const queryClient = new QueryClient()

const ApplicationWrapper = ({ element }: { element: any }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <RecoilRoot>
          <BootstrapApplication>{element}</BootstrapApplication>
        </RecoilRoot>
      </Provider>
    </QueryClientProvider>
  )
}

export default ApplicationWrapper
